import * as React from "react";
import BaseComponent from "src/engine/ui/BaseComponent";
import "./index.scss";

interface IProps {
    handleEndAni: () => void;
}

interface IState {
    loading: boolean;
}

const openAniUrl = "https://webcloudplt.oss.jjbisai.com/fw/0/6fb1e3a4500e332b_5570816.ts";

// 页面打开动画（开门）
class PreAni extends BaseComponent<IProps, IState> {
    private video: any;

    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: true,
        };
        this.video = null;
    }

    componentDidMount() {
        this.initVideo();
    }

    componentWillUnmount() {
        this.video.stop();
    }

    // 初始化视频
    initVideo = () => {
        // @ts-ignore
        this.video = new JSMpeg.Player(openAniUrl, {
            canvas: document.getElementById("video"),
            loop: false,
            autoplay: true,
            throttled: false,
            progressive: false,
            onEnded: this.props.handleEndAni,
            onSourceEstablished: () => {
                this.setState({
                    loading: false,
                });
            },
        });
        this.video.play();
    };

    render() {
        const { loading } = this.state;
        return (
            <div className="pre-ani-page">
                {loading ? (
                    <div className="pre-pic">
                        <div className="door-logo"></div>
                    </div>
                ) : null}
                <canvas id="video" className={loading ? "pre-ani hidden" : "pre-ani"} width={"7.5rem"} height={"16rem"}></canvas>
            </div>
        );
    }
}

export default PreAni;
